import { createSlice } from "@reduxjs/toolkit";
import { fetchUserData, fetchUserList } from "./thunk";
import { UserSlice } from "types/users";
import { ERROR } from "types";


const initialState: UserSlice = {
    count: 0,
    list: [],
    loading: true,
    page: 1,
    last_fetched_at: null,
    has_more: true,
    expired: true,
    error: null,
    itemLoading: true,
    items: {}
}

const userListSlice = createSlice({
    name: 'userList',
    initialState,
    reducers: {
        markUserListExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserList.pending, (state) => {
                state.loading = true;
                state.error = null
            })
            .addCase(fetchUserList.fulfilled, (state, action) => {
                state.list = action.payload.page === 1 ?
                    action.payload.userList.items :
                    [...state.list, ...action.payload.userList.items];

                state.count = action.payload.userList.count;
                state.page = action.payload.page;
                state.loading = false;
                state.has_more = action.payload.userList.count > state.list.length;
                state.last_fetched_at = Date.now();
                state.expired = false;
            })
            .addCase(fetchUserList.rejected, (state, action) => {
                state.loading = false;
                if(action.payload !== ERROR.CACHED)
                    state.error = action.payload || 'Failed to fetch users'
            })
            .addCase(fetchUserData.pending, (state) => {
                state.itemLoading = true;
                state.error = null;
            })
            .addCase(fetchUserData.fulfilled, (state, action) => {
                state.items[action.payload.uuid] = {
                    user: action.payload,
                    last_fetched_at: Date.now()
                }
                state.itemLoading = false;
                state.error = null;
            })
            .addCase(fetchUserData.rejected, (state, action) => {
                state.itemLoading = false;
                state.error = action.payload || 'Failed to fetch user data';
            })
    }
})

export const { markUserListExpired } = userListSlice.actions;

export default userListSlice.reducer;